import { configureStore } from '@reduxjs/toolkit';
import supportReducer from './features/supportSlice';
import authReducer from './features/partnerSlice';
import usersReducer from './features/usersSlice';
import userReducer from './features/userInfo';
import partnersReducer from './features/partnersSlice';
import userBookingsReducer from './features/user/BookingsSlice';
import reportReducer from './features/reportSlice'
import fieldOfficerReducer from './features/fieldOfficerSlice'
import fieldOfficerInfoReducer from './features/fieldOfficerInfo'
import reportsSliceReducer from './features/reportsSlice'
import createReportReducer from './features/createReportSlice';
import sampleReducer from './features/sampleSlice';
import logsReducer from './features/logSlice';
import fieldOfficersSliceReducer from './features/fieldOfficersSlice'
import userFarmsSliceReducer from './features/userFarmsSlice'
import farmerProfileReducer from './features/farmerProfileSlice';
import farmerSliceReducer from './features/farmerSlice';
import profileSliceReducer from './features/profileSlice';
import fieldOfficerByPartnerReducer from './features/fieldOfficerByPartnerSlice';
import devicesReducer from './features/devicesSlice';
import roleReducer from './features/roleSlice';
import soilAnomalyLogReducer from './features/soilAnomalyLogSlice';


export const store = configureStore({
  reducer: {
    support: supportReducer,
    partner: authReducer,
    users: usersReducer,
    userInfo: userReducer,
    partners: partnersReducer,
    userBookings: userBookingsReducer,
    report: reportReducer,
    fieldOfficers: fieldOfficerReducer,
    fieldOfficerInfo: fieldOfficerInfoReducer,
    reports: reportsSliceReducer,
    createReport: createReportReducer,
    sample: sampleReducer,
    logs: logsReducer,
    fieldOfficer: fieldOfficersSliceReducer,
    userFarms: userFarmsSliceReducer,
    farmerProfile: farmerProfileReducer,
    farmer: farmerSliceReducer,
    profile: profileSliceReducer,
    fieldOfficerByPartner: fieldOfficerByPartnerReducer,
    devices: devicesReducer,
    role: roleReducer,
    soilAnomalyLogs: soilAnomalyLogReducer,
  },
});
